import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

function generateCouponCode() {
  const part1 = Math.random().toString(36).substring(2, 6).toUpperCase();
  const part2 = Date.now().toString(36).slice(-4).toUpperCase();
  return `JJS${part1}${part2}`;
}

const resources = {
  en: {
    translation: {
      Dashboard: 'Dashboard',
      Products: 'Products',
      Orders: 'Orders',
      Settings: 'Settings',
      'Dark Mode': 'Dark Mode',
      'Theme Color': 'Theme Color',
      Language: 'Language',
      English: 'English',
      Vietnamese: 'Vietnamese',
      Collapse: 'Collapse',
      Promotions: 'Promotions',
      Code: 'Code',
      'Code is required': 'Code is required',
      'A unique code for the coupon (e.g. SUMMER2025)': 'A unique code for the coupon (e.g. SUMMER2025)',
      'Generate Random Code': 'Generate Random Code',
      'Discount Percentage': 'Discount Percentage',
      'Percentage discount': 'Percentage discount',
      'Discount must be between 0 and 100': 'Discount must be between 0 and 100',
      'Percentage off the total order (0–100%)': 'Percentage off the total order (0–100%)',
      'Discount Amount': 'Discount Amount',
      'Fixed amount discount to apply (e.g. 50)': 'Fixed amount discount to apply (e.g. 50)',
      'Max Discount Amount': 'Max Discount Amount',
      'Maximum discount value allowed (if applicable)': 'Maximum discount value allowed (if applicable)',
      'Start Date': 'Start Date',
      'Start date is required': 'Start date is required',
      'Date and time the coupon becomes active': 'Date and time the coupon becomes active',
      'End Date': 'End Date',
      'End date is required': 'End date is required',
      'End date must be after start date': 'End date must be after start date',
      'Date and time the coupon expires': 'Date and time the coupon expires',
      'Min Order Value': 'Min Order Value',
      'Minimum order amount to use this coupon': 'Minimum order amount to use this coupon',
      'Value must be >= 0': 'Value must be >= 0',
      'Usage Limit': 'Usage Limit',
      'Maximum number of times this coupon can be used': 'Maximum number of times this coupon can be used',
      'Usage limit must be >= 0': 'Usage limit must be >= 0',
      'Total allowed uses': 'Total allowed uses',
      Note: 'Note',
      'Internal notes or description for this coupon': 'Internal notes or description for this coupon',
      Type: 'Type',
      'Type is required': 'Type is required',
      'E.g. percentage, fixed, shipping': 'E.g. percentage, fixed, shipping',
      Status: 'Status',
      'Invalid status': 'Invalid status',
      'Select whether the coupon is active': 'Select whether the coupon is active',
      Active: 'Active',
      Inactive: 'Inactive',
      'Free Shipping': 'Free Shipping',
      'Enable this if the coupon provides free shipping': 'Enable this if the coupon provides free shipping',
      Cancel: 'Cancel',
      Update: 'Update',
      Create: 'Create',
      'Update Coupon': 'Update Coupon',
      'Create New Coupon': 'Create New Coupon'
    }
  },
  vi: {
    translation: {
      Dashboard: 'Tổng quan',
      Products: 'Sản phẩm',
      Orders: 'Đơn hàng',
      Settings: 'Cài đặt',
      'Dark Mode': 'Chế độ tối',
      'Theme Color': 'Màu chủ đề',
      Language: 'Ngôn ngữ',
      English: 'Tiếng Anh',
      Vietnamese: 'Tiếng Việt',
      Collapse: 'Thu gọn',
      Promotions: 'Khuyến mãi',
      'CMS Management': 'Quản lý CMS',
      Title: 'Tiêu đề',
      Subtitle: 'Tiêu đề phụ',
      Description: 'Mô tả',
      Type: 'Loại',
      'Display Order': 'Thứ tự hiển thị',
      Active: 'Kích hoạt',
      'Created At': 'Ngày tạo',
      Actions: 'Hành động',
      'Edit CMS': 'Chỉnh sửa CMS',
      'Update CMS': 'Cập nhật nội dung',
      'Select Image': 'Chọn ảnh',
      Cancel: 'Hủy',
      Update: 'Cập nhật',
      Export: 'Xuất Excel',
      'Exported to Excel': 'Đã xuất Excel thành công',
      'CMS updated successfully': 'Cập nhật CMS thành công',
      'Failed to update CMS': 'Không thể cập nhật CMS',
      'Failed to update status': 'Không thể cập nhật trạng thái',
      'CMS status updated': 'Cập nhật trạng thái thành công',
      'No CMS data available': 'Không có dữ liệu CMS',
      Yes: 'Có',
      No: 'Không',
      Code: 'Mã giảm giá',
      'Code is required': 'Vui lòng nhập mã giảm giá',
      'A unique code for the coupon (e.g. SUMMER2025)': 'Mã giảm giá duy nhất (ví dụ: SUMMER2025)',
      'Generate Random Code': 'Tạo mã ngẫu nhiên',
      'Discount Percentage': 'Phần trăm giảm',
      'Percentage discount': 'Giảm theo phần trăm',
      'Discount must be between 0 and 100': 'Phần trăm phải từ 0 đến 100',
      'Percentage off the total order (0–100%)': 'Giảm giá theo phần trăm trên tổng đơn hàng',
      'Discount Amount': 'Số tiền giảm',
      'Fixed amount discount to apply (e.g. 50)': 'Giảm cố định theo số tiền (ví dụ: 50)',
      'Max Discount Amount': 'Giảm tối đa',
      'Maximum discount value allowed (if applicable)': 'Số tiền giảm tối đa được phép (nếu có)',
      'Start Date': 'Ngày bắt đầu',
      'Start date is required': 'Vui lòng nhập ngày bắt đầu',
      'Date and time the coupon becomes active': 'Thời gian mã bắt đầu có hiệu lực',
      'End Date': 'Ngày kết thúc',
      'End date is required': 'Vui lòng nhập ngày kết thúc',
      'End date must be after start date': 'Ngày kết thúc phải sau ngày bắt đầu',
      'Date and time the coupon expires': 'Thời gian mã hết hiệu lực',
      'Min Order Value': 'Giá trị đơn tối thiểu',
      'Minimum order amount to use this coupon': 'Giá trị đơn hàng tối thiểu để áp dụng mã',
      'Value must be >= 0': 'Giá trị phải >= 0',
      'Usage Limit': 'Giới hạn sử dụng',
      'Maximum number of times this coupon can be used': 'Số lần mã được sử dụng tối đa',
      'Usage limit must be >= 0': 'Giới hạn sử dụng phải >= 0',
      'Total allowed uses': 'Tổng số lượt cho phép',
      Note: 'Ghi chú',
      'Internal notes or description for this coupon': 'Ghi chú nội bộ hoặc mô tả cho mã giảm giá',
      'Type is required': 'Vui lòng nhập loại mã',
      'E.g. percentage, fixed, shipping': 'Ví dụ: phần trăm, cố định, miễn phí vận chuyển',
      Status: 'Trạng thái',
      'Invalid status': 'Trạng thái không hợp lệ',
      'Select whether the coupon is active': 'Chọn trạng thái hoạt động của mã',
      Inactive: 'Không hoạt động',
      'Free Shipping': 'Miễn phí vận chuyển',
      'Enable this if the coupon provides free shipping': 'Bật nếu mã áp dụng miễn phí vận chuyển',
      Create: 'Tạo mới',
      'Update Coupon': 'Cập nhật mã giảm giá',
      'Create New Coupon': 'Tạo mã giảm giá mới',
      'Sales': 'Bán hàng',
  'Search Products': 'Tìm kiếm sản phẩm',
  'Search by name or SKU...': 'Tìm theo tên hoặc mã SKU...',
  'Stock': 'Tồn kho',
  'Find customer (F4)': 'Tìm khách hàng (F4)',
  'No products in cart': 'Chưa có sản phẩm trong giỏ hàng',
  'Subtotal': 'Tổng tiền hàng',
  'Discount': 'Giảm giá',
  'Other Tax': 'Thu khác',
  'Total': 'Tổng cộng',
  'Checkout': 'Thanh toán',
  'Order notes': 'Ghi chú đơn hàng',
  'Quick Sale': 'Bán nhanh',
  'Bonus Sale': 'Bán thưởng',
  'Set Discount': 'Thiết lập giảm giá',
  'Discount Value': 'Giá trị giảm',
  'Apply': 'Áp dụng'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
export { generateCouponCode };
